import IQueries from "@/interfaces/IQueries";

// Path with parameters
const moods: IQueries = {
  fetchAppConfigs: {
    path: "/astrology/astrology_app_configs",
    method: "GET",
  },
  createAppConfig: {
    path: "/astrology/astrology_app_configs",
    method: "POST",
  },
  fetchAppConfig: {
    path: "/astrology/astrology_app_configs/",
    method: "GET",
  },
  updateAppConfig: {
    path: "/astrology/astrology_app_configs/",
    method: "PUT",
  },
  deleteAppConfig: {
    path: "/astrology/astrology_app_configs/",
    method: "DELETE",
  },
};

export default moods;
